import _ from 'lodash'
import { getRegionTrees } from '@/api/billing'

let regionTrees = null;
export const getRegionTreesByCache = () => {
  return new Promise((resolve, reject) => {
    if (regionTrees == null) {
      getRegionTrees().then(data => {
        regionTrees = data;
        resolve(regionTrees);
      }, error => {
        reject(error);
      });
    } else {
      resolve(regionTrees);
    }
  });
};

let regionRecords = null;

export const nodes2Records = (parentNode, nodes) => {
  let records = [];
  for (let i = 0, len = nodes.length; i < len; i++) {
    let node = nodes[i];
    let record = {
      code: node.code,
      name: node.name,
      type: node.type,
    };
    if (parentNode != null) {
      record.parentCode = parentNode.code;
      record.parentName = parentNode.name;
      record.parentType = parentNode.type;
    }
    records.push(record);
    if (node.children != null && node.children.length > 0) {
      records = records.concat(nodes2Records(node, node.children));
    }
  }
};

export const trees2Records = trees => {
  return trees == null ? null : nodes2Records(null, trees);
};

export const getRegionRecordsByCache = () => {
  return new Promise((resolve, reject) => {
    if (regionRecords == null) {
      getRegionTreesByCache().then(regionTrees => {
        regionRecords = trees2Records(regionTrees);
      }, error => {
        reject(error);
      });
    } else {
      resolve(regionRecords);
    }
  });
};

export async function getRoots() {
  let regionTrees = await getRegionTreesByCache();
  return regionTrees.map(regionTree => ({
    name: regionTree.name,
    code: regionTree.code,
    type: regionTree.type,
  }));
}

export async function getChildren(parentCode, parentName) {
  let children;
  if (parentCode == null && parentName == null) {
    // children = await getRoots();
    children = [];
  } else {
    let regionTrees = await getRegionTreesByCache();
    let parentRegion = null;
    while (regionTrees != null && regionTrees.length > 0) {
      let regions = regionTrees.filter(region => (parentCode == null || parentCode === region.code) &&
          (parentName == null || parentName === region.name));
      if (regions != null && regions.length > 0) {
        parentRegion = regions[0];
        break;
      }
      regionTrees = _.flatMap(_.map(regionTrees, regionTree => regionTree.children));
    }
    children = parentRegion == null ? [] : parentRegion.children;
  }
  return children;
}


